var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlacksetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10248",
    "data-name": "Group 10248",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    "data-name": "Path 3351",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    "data-name": "Path 3352",
    d: "M3.055,12.625a7.1,7.1,0,0,1-.693-1.648,2.125,2.125,0,0,0,0-3.788A7.077,7.077,0,0,1,4.135,4.118a2.125,2.125,0,0,0,3.28-1.894,7.077,7.077,0,0,1,3.547,0,2.125,2.125,0,0,0,3.281,1.893,7.139,7.139,0,0,1,1.773,3.072,2.125,2.125,0,0,0,0,3.788,7.077,7.077,0,0,1-1.772,3.072,2.125,2.125,0,0,0-3.28,1.894,7.077,7.077,0,0,1-3.547,0,2.125,2.125,0,0,0-3.281-1.893,7.1,7.1,0,0,1-1.08-1.424Zm4.009.139a3.537,3.537,0,0,1,1.594,1.962,5.657,5.657,0,0,0,1.062,0,3.545,3.545,0,0,1,4.092-2.362,5.62,5.62,0,0,0,.53-.919,3.544,3.544,0,0,1,0-4.723A5.756,5.756,0,0,0,13.81,5.8,3.541,3.541,0,0,1,9.721,3.44a5.657,5.657,0,0,0-1.062,0A3.544,3.544,0,0,1,4.567,5.8a5.66,5.66,0,0,0-.53.919,3.544,3.544,0,0,1,0,4.723,5.756,5.756,0,0,0,.531.919A3.537,3.537,0,0,1,7.064,12.764Zm2.125-1.556a2.125,2.125,0,1,1,2.125-2.125A2.125,2.125,0,0,1,9.189,11.208Zm0-1.417a.708.708,0,1,0-.708-.708A.708.708,0,0,0,9.189,9.792Z",
    transform: "translate(-0.689 -0.583)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacksetting);
export default __webpack_public_path__ + "static/media/blacksetting.bc3c0f48f6b69f4dda3c8d5c07e99b89.svg";
export { ForwardRef as ReactComponent };